import type { JSX } from 'react';
import { useAuth0, User } from '@auth0/auth0-react';
import { useAuthAppContext } from '../../context/useAuthAppContext';
import AccountComponent from './components/userAccountTabs';
import { Navigate, useParams } from 'react-router-dom';
import { AccountTabEnum, getAccountTab, isValidAccountTab } from './constants/account.constants';
import { AppRoutes } from '../../types/appRoutes';

const UserAccount = (): JSX.Element => {
  const { user: auth0User } = useAuth0<{ user: User }>();
  const { isAuthenticated, keyUser, authMethod } = useAuthAppContext();
  const { tab } = useParams();

  if (tab !== undefined && !isValidAccountTab(tab)) {
    return <Navigate to={AppRoutes.routeUserAccount} replace />;
  }

  // Get user from appropriate source based on authentication method
  const user = authMethod === 'key' ? keyUser : auth0User;

  if (isAuthenticated && user) {
    const selectedTab: AccountTabEnum | undefined = getAccountTab(tab);

    return <AccountComponent user={user} selectedTab={selectedTab} />;
  }

  return <Navigate to={AppRoutes.routeErrorPage} replace />;
};

export default UserAccount;
